// Module dependencies
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// UI
import { Strong, Text, TextLink } from 'components/catalyst/text';

// Utils
import { getAppVersion } from 'utils/version';

const Footer: FC = () => {
  const { t } = useTranslation('common');
  const appVersion = getAppVersion();
  
  const linkList = [
    {
      label: t('FOOTER_TERMS'),
    },
    {
      label: t('FOOTER_ABOUT'),
    },
    {
      label: t('FOOTER_CONTACT'),
    },
  ];

  return (
    <div className='flex flex-col md:flex-row justify-center items-center gap-2 w-full md:h-[52px] pb-4 md:pb-0'>
      <Text>
        <Strong className='!text-xs !text-zinc-400'>
          {t('FOOTER_NIMAX')}
        </Strong>
      </Text>

      <div className='h-[16px] border w-[1px] hidden md:block'></div>

      <Text className='!text-xs !text-zinc-400'>
        {t('FOOTER_VERSION', { version: appVersion })}
      </Text>

      <div className='flex items-center gap-2'>
        {linkList.map(({ label }) => (
          <Text key={label} className='!leading-none'>
            <TextLink>
              {label}
            </TextLink>
          </Text>
        ))}
      </div>
    </div>
  );
};

export default Footer;
